import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
  // If pre-rendered by react-snap, use hydrate
  ReactDOM.hydrate(<App />, rootElement);
} else {
  // Otherwise use normal render
  ReactDOM.render(<App />, rootElement);
}


